/**
 * Obsługa funkcjonalności dla ostatnio oglądanych produktów
 */
app.service('lastProducts',function(cookie, loading){
	function clear(){
		loading.start();
		$.ajax({
			url: '/last-viewed-products-updater.ltr',
			method:'POST',
			data:{
				action: 'removeAll'
			}, complete: function () {
				loading.stop();
			}
		});
	}

	function getProducts() {
		var cookieString = cookie.get('lastViewedProducts'); //product-top

		if(!cookie.isEmpty('lastViewedProducts')) {
			var products = cookieString.split('a');
			var actualProductId = $('#product-top').data('product') || false;

			if (actualProductId) {
				var actualProductIndex = products.indexOf(String(actualProductId));
				products.splice(actualProductIndex, 1);
			}

			return products;
		} else {
			return [];
		}
	}

	return {
		getProducts:getProducts,
		clear: clear
	};
});
